export default {"src":"/_next/static/media/hero.4c553552.svg","height":458,"width":693,"blurWidth":0,"blurHeight":0};